import React, { useRef, useMemo, useEffect } from 'react';
import { Dispatcher } from '@sui/sui';
import { addModel, createContextStateModel } from '@@/core/plugin-model';
import * as app from '@/app';
const { getContextState } = app || {};
async function _getContextState(parentContext, topContext) {
  let res
  if( typeof getContextState === 'function'  ){
    res = await getContextState(parentContext, topContext);
  } else {
    res = getContextState
  }
  return res || {}
}
const models = {};
addModel(models, 'context', createContextStateModel(_getContextState) );


export const dispatcher = new Dispatcher();

function Executor(props) {
  const { hook, onUpdate, namespace } = props;
  const updateRef = useRef(onUpdate);
  const initialLoad = useRef(false);

  let data;
  try {
    data = hook();
  } catch (e) {
    console.error(
      `plugin-model: Invoking '${namespace || 'unknown'}' model failed:`,
      e,
    );
  }

  // 首次执行时立刻返回初始值
  useMemo(() => {
    typeof updateRef.current === 'function' && updateRef.current(data);
  }, []);

  // React 16.13 后 update 函数用 useEffect 包裹
  useEffect(() => {
    if (initialLoad.current) {
      typeof updateRef.current === 'function' && updateRef.current(data);
    } else {
      initialLoad.current = true;
    }
  });

  return null;
}

export function ModelsProvider(props){
        return <>{Object.keys(models).map(namespace =>{
            return (<Executor
                        key={namespace}
                        namespace={namespace}
                        hook={models[namespace]}
                        onUpdate={
                           val => {
                                dispatcher.data[namespace] = val;
                                dispatcher.update(namespace);
                            }
                        }
                    />)
        })}
        { props.children }
        </>
}

export default models;
// generated at 2025/8/22 09:24:41 by sui v3.1.124